import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';

import { ProductScreenComponent } from './components/product-screen/product-screen.component';
import { PricingScreenComponent } from './components/pricing-screen/pricing-screen.component';
import { SearchScreenComponent } from './components/search-screen/search-screen.component';
import { ErrorPageComponent } from './commons/error-page/error-page.component';

//materials library
import { MatDialogModule } from "@angular/material/dialog";
import { MatInputModule } from "@angular/material/input";
import { MatMenuModule } from "@angular/material/menu";
import { MatCardModule } from "@angular/material/card";
import { MatSelectModule } from "@angular/material/select";
import { MatButtonModule } from "@angular/material/button";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatChipsModule } from "@angular/material/chips";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatNativeDateModule } from "@angular/material/core";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatIconModule } from "@angular/material/icon";
import { MatBadgeModule } from "@angular/material/badge";
import { MatRadioModule } from "@angular/material/radio";
import { MatStepperModule } from "@angular/material/stepper";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatListModule } from "@angular/material/list";
import { MatTabsModule } from "@angular/material/tabs";
import { MatTreeModule } from "@angular/material/tree";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatTableModule } from "@angular/material/table";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatProgressBarModule } from '@angular/material/progress-bar';

//coreui
import { CarouselModule } from '@coreui/angular';
//charts
import { NgxChartsModule } from '@swimlane/ngx-charts';


import { HomeComponent } from './components/home/home.component';
import { AboutUsComponent } from './commons/about-us/about-us.component';
import { TermsOfServiceComponent } from './commons/terms-of-service/terms-of-service.component';
import { PrivacyPolicyComponent } from './commons/privacy-policy/privacy-policy.component';
import { EbayBrowseItemComponent } from './components/ebay-browse-item/ebay-browse-item.component';
import { AmazonItemComponent } from './components/amazon-item/amazon-item.component';
import { LoadingScreenComponent } from './utils/components/loading-screen/loading-screen.component';

// auth components
import { LoginComponent } from './auth/login/login.component';
import { RegisterComponent } from './auth/register/register.component';
import { ForgotPasswordComponent } from './auth/forgot-password/forgot-password.component';
import { UpdatePasswordComponent } from './auth/update-password/update-password.component';
import { TokenVerificationComponent } from './auth/token-verification/token-verification.component';
import { ResetPasswordComponent } from './auth/reset-password/reset-password.component';
import { UpdateEmailComponent } from './auth/update-email/update-email.component';
import { ContactComponent } from './commons/contact/contact.component';
import { ReAuthComponent } from './auth/re-auth/re-auth.component';
import { NavBarComponent } from './commons/nav-bar/nav-bar.component';
import { EmailVerificationComponent } from './auth/email-verification/email-verification.component';
import { AccountDisabledComponent } from './auth/account-disabled/account-disabled.component';

// finance components
import { SuccessComponent } from './payment/success/success.component';
import { CartViewComponent } from './payment/cart-view/cart-view.component';
import { SubPricingComponent } from './commons/sub-pricing/sub-pricing.component';
import { SettingsComponent } from './payment/settings/settings.component';


@NgModule({ declarations: [
        AppComponent,
        ProductScreenComponent,
        PricingScreenComponent,
        SearchScreenComponent,
        HomeComponent,
        AboutUsComponent,
        TermsOfServiceComponent,
        PrivacyPolicyComponent,
        EbayBrowseItemComponent,
        AmazonItemComponent,
        ErrorPageComponent,
        LoadingScreenComponent,
        LoginComponent,
        RegisterComponent,
        ForgotPasswordComponent,
        UpdatePasswordComponent,
        TokenVerificationComponent,
        ResetPasswordComponent,
        UpdateEmailComponent,
        CartViewComponent,
        SuccessComponent,
        ContactComponent,
        SettingsComponent,
        NavBarComponent,
        EmailVerificationComponent,
        AccountDisabledComponent,
        SubPricingComponent,
        ReAuthComponent,
    ],
    bootstrap: [AppComponent], imports: [FormsModule,
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        MatExpansionModule,
        MatTableModule,
        MatDialogModule,
        MatSidenavModule,
        MatIconModule,
        MatInputModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatMenuModule,
        MatFormFieldModule,
        MatSnackBarModule,
        MatBadgeModule,
        MatCardModule,
        MatSelectModule,
        MatButtonModule,
        MatCheckboxModule,
        MatChipsModule,
        MatProgressSpinnerModule,
        MatToolbarModule,
        MatRadioModule,
        MatStepperModule,
        MatTooltipModule,
        MatListModule,
        MatTreeModule,
        MatTabsModule,
        MatPaginatorModule,
        MatProgressBarModule,
        CarouselModule,
        NgxChartsModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class AppModule { }
